import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    headerCell: {
        "& th": {
            background: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            fontWeight: "bold",
        }
    },
    customTableCell: {
        padding: theme.spacing(0.5, 2)
    },
    // Checkov Details
    dialogContent: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    // Pland And Apply styles
    planRoot: {
        display: "flex",
        flexDirection: "column",
        width: '100%'
    },
    gridView: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        margin: theme.spacing(0.5, 0),
        "& hr": {
            margin: theme.spacing(0.5, 0),
        }
    },
    tableHeaderClass: {
        "& th": {
            background: theme.palette.blue[9],
            color: theme.palette.text.primary,
            fontWeight: "bold",
            "& span": {
                color: "inherit",
                "&:hover": {
                    color: "inherit"
                }
            },
        }
    },
}));
